import './assign_global_jquery'
import './assign_global_lodash'
import './assign_ua_parser'
import '../../../vendor/assets/javascripts/modernizr'
import 'foundation-sites/js/foundation'
import '../../../vendor/assets/javascripts/bootstrap-datepicker.min'
import '../../../vendor/assets/javascripts/jquery.serialize-object'
import '../../../vendor/assets/javascripts/jquery.tooltipster'
import '../../../vendor/assets/javascripts/jquery.color'
import '../../../vendor/assets/javascripts/twitter-text'

import './frontend_invite_a_friend/frontend_invite_a_friend'
import './frontend_invite_a_friend/browser_storage'

import './frontend_invite_a_friend/helpers'
import './frontend_invite_a_friend/controllers'
import './frontend_invite_a_friend/views'

$(function () {
  $(document).foundation({
    tooltip: {
      additional_inheritable_classes: ['tip-left-top']
    }
  })
  Buyapowa.initialize()
})
